import React, {Component} from 'react'
import { connect } from 'react-redux'
import { Spinner, WikiEditor } from '../../components/index'
import CollapsibleComment from './CollapsibleComment'
import { selectIsRequestPending } from '../../util/index'

import Button from '@atlaskit/button'

import { selectADUserInfo } from '../../auth/reducer'
import { getIssueComments, addIssueComment, updateIssueComment } from '../actions'
import { selectIssueComments } from '../reducer'

class CommentSection extends Component {

    constructor (props, ...args) {
        super(props, ...args),
        this.state = {
            createNew: false,
            editing: false,
            hideOld: true,
        }
    }

    componentWillMount() {
        let { Issue, getIssueComments } = this.props
        getIssueComments(Issue.key).catch(err => console.error(err))
    }    

    handleUpdate = (value) => {
        let { Issue, updateIssueComment } = this.props
        updateIssueComment(Issue.key, value)
        
    }

    handleEditing = () => {        
        this.setState({editing: !this.state.editing})
    }

    handleCreateSubmit = (values) => {
        let { Issue, addIssueComment } = this.props
        addIssueComment(Issue.key, values)
        this.setState({createNew: false})
    }

    handleCreate = () => {        
        this.setState({createNew: true})
    }    

    handleCreateCancel = () => {
        this.setState({createNew: false})
    }

    handleShowHidden = () => {
        this.setState({hideOld: false})
    }
    // TODO: CSS to get this section looking right still needs to be setup, and onClick isn't working span isn't actually clickable.
    collapsedOlderComments = (comments) => {
        let shownComments = comments.slice(comments.length - 4)
        let countHidden = comments.length - 4        
        return (
            <div>
                <p className='older-comments fancy'><span onClick={this.handleShowHidden}>{`${countHidden} older comments`}</span></p>
                {shownComments}
            </div>            
        )
    }

    render () {
        let { Issue, issueComments, isCommentsPending, user, isAddCommentPending, isUpdateCommentPending } = this.props        
        if ( isCommentsPending ) return (<Spinner medium />)
        let comments = issueComments.map(comment => {            
            return (
                <CollapsibleComment key={comment.id} 
                    comment={comment} 
                    onUpdate={this.handleUpdate} 
                    user={user} 
                    editingComment={this.state.editing}
                    onEditing={this.handleEditing}
                    updatePending={isUpdateCommentPending}                    
                    />
            )
        })        
        //let commentsSection = comments.length < 5 ? comments : this.collapsedOlderComments(comments)
        let commentsSection = comments
        return (
            isUpdateCommentPending || isAddCommentPending?
                <Spinner large /> :
                <div className='comment-section-container'>                    
                    {commentsSection}
                    {
                        this.state.createNew ? <WikiEditor 
                                                    key='newComment'
                                                    onSave={this.handleCreateSubmit}
                                                    onCancel={this.handleCreateCancel}                                                     
                                                    />
                        : <Button type='button' appearance='primary' onClick={this.handleCreate}>Add Comment</Button>
                    }
                </div>
        )
    }
}

export default connect(state => {
    return {
        issueComments: selectIssueComments(state),        
        isCommentsPending: selectIsRequestPending(state, getIssueComments),
        isUpdateCommentPending: selectIsRequestPending(state, updateIssueComment),
        isAddCommentPending: selectIsRequestPending(state, addIssueComment),
        user: selectADUserInfo(state),        
    }
    
}, {getIssueComments, addIssueComment, updateIssueComment })(CommentSection)


// WEBPACK FOOTER //
// ./client/src/serviceDesk/components/CommentSection.js